import { Credentials } from './../objects/real-time';
import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { GlobalService } from './global.config';
import { contentHeaders, createAuthorizationHeader } from '../utils/headers';
import { User } from '../objects/real-time';
import { Events } from 'ionic-angular';
@Injectable()
export class SigningService {
	dns: string;
	//dns = this.globalService.getDns();
	constructor(public http: Http, private globalService: GlobalService, public events: Events) {
		this.events.subscribe('dns', (dns) => {
			//console.log(path);
			if (dns) {
				this.dns = dns;
			}
		});
	}

	login(credentials: any) {
		return this.http.post(this.dns + 'signin', credentials, { headers: contentHeaders }).map((res) => res.json());
	}

	logout() {
		let headers = new Headers({ Accept: 'application/json' });
		createAuthorizationHeader(headers);
		return this.http.post(this.dns + 'signout', {}, { headers: headers }).map((res) => res.json());
	}
}



// WEBPACK FOOTER //
// ./src/providers/login.ts